import {
	Button,
	Input,
	InputSelect,
	RiDeleteBin2Fill
} from "@itandi/itandi-bb-ui";
import type React from "react";
import { useFormContext } from "react-hook-form";
import type { SurveySetting } from "~/models/Survey";
import Styles from "./SurveyForm.module.scss";

type Props = {
	deleteOption: (index: number) => void;
	surveyOptionIndex: number;
};
export const SurveyOptionSettingForm: React.FC<Props> = ({
	surveyOptionIndex,
	deleteOption
}: Props) => {
	const { register, formState } = useFormContext<SurveySetting>();
	const textError =
		formState.errors.surveyOptions?.[surveyOptionIndex]?.text || null;
	const valueError =
		formState.errors.surveyOptions?.[surveyOptionIndex]?.value || null;
	return (
		<>
			<div className={Styles.Options}>
				<Input
					isInvalid={textError != null}
					{...register(`surveyOptions.${surveyOptionIndex}.text`)}
				/>
				<span>
					<InputSelect
						isInvalid={valueError != null}
						{...register(`surveyOptions.${surveyOptionIndex}.value`)}
					>
						<option value="5">+5</option>
						<option value="4">+4</option>
						<option value="3">+3</option>
						<option value="2">+2</option>
						<option value="1">+1</option>
						<option value="0">0</option>
						<option value="-1">-1</option>
						<option value="-2">-2</option>
						<option value="-3">-3</option>
						<option value="-4">-4</option>
						<option value="-5">-5</option>
					</InputSelect>
				</span>
				<Button
					onClick={(): void => {
						deleteOption(surveyOptionIndex);
					}}
					startIcon={<RiDeleteBin2Fill className={Styles.Icon} />}
					variant="iconTransparent"
				>
					{" "}
				</Button>
			</div>
			{textError != null && (
				<div className={Styles.InvalidFeedback}>{textError.message}</div>
			)}
			{valueError != null && (
				<div className={Styles.InvalidFeedback}>{valueError.message}</div>
			)}
		</>
	);
};
